import { Component, Input } from '@angular/core';

/**
 * Volume, wood EUR/m3 (with margin, `salePrice`) and wood total for an offer (D17). Every number comes from the
 * backend (`volumeM3`, `salePrice`, `woodTotal`); the browser only formats them.
 */
@Component({
  selector: 'app-offer-totals-summary',
  templateUrl: './offer-totals-summary.component.html',
  styleUrls: ['./offer-totals-summary.component.scss'],
})
export class OfferTotalsSummaryComponent {
  @Input() offer: any = null;
  @Input() currency: string | null = null;
  /** One line version for list rows. */
  @Input() compact = false;

  get currencyCode(): string {
    return (
      this.currency ||
      this.offer?.Pricings?.find((p: any) => p.isMainCurrency)?.currency?.name ||
      'EUR'
    );
  }
}
